import { useState } from "react";

import { Api } from "@noom/noomscape";

import { Address } from "@/models";
import { validateAndGetCorrectedAddress } from "@/utils/address";
import { getAutologinData } from "@/utils/cookies";
import { buildAddressProto } from "@/utils/proto";

export const useOrderScale = () => {
  const [isLoading, setIsLoading] = useState(false);

  const orderScale = async (
    shippingAddress: Address,
    recipient?: string,
  ): Promise<Address> => {
    const autologinData = getAutologinData();
    if (!autologinData) {
      throw new Error("No autologin data found");
    }
    const { accessCode, accessToken } = autologinData;
    if (!accessCode || !accessToken) {
      throw new Error("No autologin data found");
    }
    setIsLoading(true);

    try {
      const correctedAddress =
        await validateAndGetCorrectedAddress(shippingAddress);
      await Api.call("scales.orderScale", Api.api.scales.orderScale, {
        accessCode,
        shippingAddress: buildAddressProto(
          correctedAddress,
          undefined,
          recipient,
        ),
        accessToken,
      });

      return correctedAddress;
    } catch (error) {
      setIsLoading(false);
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    orderScale,
    isLoading,
  };
};
